var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-rate',_vm._b({attrs:{"name":_vm.name},on:{"change":function($event){return _vm.$emit(_vm.emitEvent, _vm.name, _vm.localModel)}},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'el-rate',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }